import {useRouter} from 'next/router';
import {useCallback} from 'react';
import {APP_ROUTES, APP_ROUTES_KEYS, APP_ROUTES_TO_URL} from '../../constants';
import {IQuery, IRouteItem, TRouteFn} from '../../types';

export const useBrandsRoute = (): IRouteItem => {
    const {push} = useRouter();

    const baseUrl = APP_ROUTES_TO_URL[APP_ROUTES_KEYS.brands];

    const redirect = useCallback(
        (fn: TRouteFn) => (query?: IQuery) => {
            const url = fn(query);
            push(url);
        },
        [push],
    );

    const url = (query?: IQuery) => (query?.id ? `${baseUrl}/${query.id}` : baseUrl);

    const to = redirect(url);

    return {section: APP_ROUTES[APP_ROUTES_KEYS.brands], to, url};
};
